import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { FileText, Folder, HardDrive } from 'lucide-react';
import { formatFileSize } from '../documentUi';

interface DocumentsStatsProps {
  folderCount: number;
  totalFiles: number;
  storageBytes: number;
}

const DocumentsStats: React.FC<DocumentsStatsProps> = ({ folderCount, totalFiles, storageBytes }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
      gap: 2,
    }}
  >
    <StatCard title="Folders" value={String(folderCount)} icon={<Folder size={22} />} />
    <StatCard title="Total files" value={String(totalFiles)} icon={<FileText size={22} />} />
    <StatCard title="Loaded size" value={formatFileSize(storageBytes)} icon={<HardDrive size={22} />} />
  </Box>
);

const StatCard: React.FC<{ title: string; value: string; icon: React.ReactNode }> = ({ title, value, icon }) => (
  <Card>
    <CardContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 2.5 }}>
      <Box>
        <Typography variant="body2" color="text.secondary">
          {title}
        </Typography>
        <Typography variant="h5" fontWeight={700} sx={{ mt: 0.5 }}>
          {value}
        </Typography>
      </Box>
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: '50%',
          bgcolor: 'grey.100',
          color: 'primary.main',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {icon}
      </Box>
    </CardContent>
  </Card>
);

export default DocumentsStats;
